export default "b8b7e127554e9da5.png"